// Dealer asset library manifest. Files live in /public/assets/dealer/.
// type: "image" renders a thumbnail preview; anything else shows a file icon.
export const ASSET_CATEGORIES = [
  {
    id: "logos",
    name: "Logos & Brand Marks",
    blurb: "Current Banner Bar logo artwork for dealer marketing, listings, and print.",
    items: [
      {
        title: "Banner Bar logo — horizontal (blue banner)",
        desc: "Primary logo lockup on transparency. For dark or light backgrounds.",
        file: "/assets/dealer/bannerbar-logo-horizontal.png",
        type: "image", format: "PNG", size: "127 KB",
      },
      {
        title: "Banner Bar logo — square (blue banner)",
        desc: "Stacked lockup on transparency. For tight spaces and profile images.",
        file: "/assets/dealer/bannerbar-logo-square.png",
        type: "image", format: "PNG", size: "295 KB",
      },
    ],
  },
  {
    id: "bungees",
    name: "Bungees",
    blurb: "Top and side bungee photography — studio and in-use shots for listings and print.",
    items: [
      {
        title: "Bungee kit — studio (top & side)",
        desc: "Full bungee set with hang tags on white — hero shot for product listings.",
        file: "/assets/dealer/bungee-kit-studio.jpg",
        type: "image", format: "JPG · 1900×1267", size: "529 KB",
      },
      {
        title: "Top Bungees — studio",
        desc: "Top bungee bundle with red hang tag and Made-in-USA mark on white.",
        file: "/assets/dealer/bungees-top-studio.jpg",
        type: "image", format: "JPG · 1900×1267", size: "410 KB",
      },
      {
        title: "Side Bungees — studio",
        desc: "Side bungee bundle with green hang tag and Made-in-USA mark on white.",
        file: "/assets/dealer/bungees-side-studio.jpg",
        type: "image", format: "JPG · 1900×1267", size: "442 KB",
      },
      {
        title: "Bungee-to-bar connection — close-up",
        desc: "Detail shot of the bungee connection at the bar — great for install guides.",
        file: "/assets/dealer/bungee-bar-connection.jpg",
        type: "image", format: "JPG · 1900×1267", size: "422 KB",
      },
      {
        title: "Single-hook bungee on banner",
        desc: "Bungee attachment at the banner edge, in the field.",
        file: "/assets/dealer/bungee-banner-attach.jpg",
        type: "image", format: "JPG · 1900×1267", size: "250 KB",
      },
    ],
  },
  {
    id: "smallform",
    name: "Small Form Frame Kit",
    blurb: "Promo card, lifestyle shot, and banner-size diagrams for the Small Form kit (2'x4' to 4'x4').",
    items: [
      {
        title: "Small Form kit — promo card",
        desc: "\"Supports 4' wide banners\" promo graphic with all four supported sizes.",
        file: "/assets/dealer/smallform-kit-promo.jpg",
        type: "image", format: "JPG · 1200×904", size: "480 KB",
      },
      {
        title: "Small Form — lifestyle",
        desc: "Small Form frame with banner in a storefront parking-lot setting.",
        file: "/assets/dealer/smallform-lifestyle.jpg",
        type: "image", format: "JPG · 1200×800", size: "606 KB",
      },
      {
        title: "Size diagram — 2' × 4' banner",
        desc: "Render-style size diagram for the 2 ft × 4 ft banner configuration.",
        file: "/assets/dealer/smallform-diagram-2x4.jpg",
        type: "image", format: "JPG · 2000×1998", size: "179 KB",
      },
      {
        title: "Size diagram — 3' × 4' banner",
        desc: "Render-style size diagram for the 3 ft × 4 ft banner configuration.",
        file: "/assets/dealer/smallform-diagram-3x4.jpg",
        type: "image", format: "JPG · 2000×1998", size: "183 KB",
      },
      {
        title: "Size diagram — 4' × 4' banner",
        desc: "Render-style size diagram for the 4 ft × 4 ft banner configuration.",
        file: "/assets/dealer/smallform-diagram-4x4.jpg",
        type: "image", format: "JPG · 2000×1998", size: "185 KB",
      },
    ],
  },
  {
    id: "twopost",
    name: "Two Post Frame Kit",
    blurb: "Promo card, lifestyle shot, and banner-size diagrams for the Two Post kit (2'x6' to 4'x8').",
    items: [
      {
        title: "Two Post kit — promo card",
        desc: "\"Supports 6' & 8' wide banners\" promo graphic with the full supported-size lineup.",
        file: "/assets/dealer/twopost-kit-promo.jpg",
        type: "image", format: "JPG · 1200×904", size: "271 KB",
      },
      {
        title: "Two Post — lifestyle",
        desc: "Two Post frame with banner installed at a parking-lot edge, blue sky.",
        file: "/assets/dealer/twopost-lifestyle.jpg",
        type: "image", format: "JPG · 1200×900", size: "374 KB",
      },
      {
        title: "Size diagram — 2' × 6' banner",
        desc: "Render-style size diagram for the 2 ft × 6 ft banner configuration.",
        file: "/assets/dealer/twopost-diagram-2x6.jpg",
        type: "image", format: "JPG · 2000×2000", size: "116 KB",
      },
      {
        title: "Size diagram — 2' × 8' banner",
        desc: "Render-style size diagram for the 2 ft × 8 ft banner configuration.",
        file: "/assets/dealer/twopost-diagram-2x8.jpg",
        type: "image", format: "JPG · 2000×2000", size: "120 KB",
      },
      {
        title: "Size diagram — 3' × 6' banner",
        desc: "Render-style size diagram for the 3 ft × 6 ft banner configuration (landscape).",
        file: "/assets/dealer/twopost-diagram-3x6.jpg",
        type: "image", format: "JPG · 2000×1237", size: "105 KB",
      },
      {
        title: "Size diagram — 3' × 8' banner",
        desc: "Render-style size diagram for the 3 ft × 8 ft banner configuration.",
        file: "/assets/dealer/twopost-diagram-3x8.jpg",
        type: "image", format: "JPG · 2000×1999", size: "118 KB",
      },
      {
        title: "Size diagram — 4' × 6' banner",
        desc: "Render-style size diagram for the 4 ft × 6 ft banner configuration.",
        file: "/assets/dealer/twopost-diagram-4x6.jpg",
        type: "image", format: "JPG · 2000×1999", size: "116 KB",
      },
      {
        title: "Size diagram — 4' × 8' banner",
        desc: "Render-style size diagram for the 4 ft × 8 ft banner configuration.",
        file: "/assets/dealer/twopost-diagram-4x8.jpg",
        type: "image", format: "JPG · 2000×1999", size: "120 KB",
      },
      {
        title: "Size diagram — 4' × 8' banner (wide layout)",
        desc: "Landscape-crop variant of the 4 ft × 8 ft diagram — fits wide listing slots.",
        file: "/assets/dealer/twopost-diagram-4x8-wide.jpg",
        type: "image", format: "JPG · 2000×1499", size: "113 KB",
      },
    ],
  },
  {
    id: "threepost",
    name: "Three Post Frame Kit",
    blurb: "Promo card, black-frame install photo, and banner-size diagrams for the Three Post kit (3'x12' to 4'x16').",
    items: [
      {
        title: "Three Post kit — promo card",
        desc: "\"Supports 12' & 16' wide banners\" promo graphic with the supported-size lineup.",
        file: "/assets/dealer/threepost-kit-promo.jpg",
        type: "image", format: "JPG · 1200×904", size: "194 KB",
      },
      {
        title: "Three Post — black frame in use",
        desc: "Black powder-coat Three Post frame with a customer banner at a real install.",
        file: "/assets/dealer/threepost-lifestyle-black.jpg",
        type: "image", format: "JPG · 1200×900", size: "483 KB",
      },
      {
        title: "Size diagram — 3' × 12' banner",
        desc: "Render-style size diagram for the 3 ft × 12 ft banner configuration.",
        file: "/assets/dealer/threepost-diagram-3x12.jpg",
        type: "image", format: "JPG · 2000×1999", size: "110 KB",
      },
      {
        title: "Size diagram — 3' × 16' banner",
        desc: "Render-style size diagram for the 3 ft × 16 ft banner configuration.",
        file: "/assets/dealer/threepost-diagram-3x16.jpg",
        type: "image", format: "JPG · 2000×1999", size: "116 KB",
      },
      {
        title: "Size diagram — 3.5' × 12' banner",
        desc: "Render-style size diagram for the 3.5 ft × 12 ft banner configuration.",
        file: "/assets/dealer/threepost-diagram-3-5x12.jpg",
        type: "image", format: "JPG · 2000×1999", size: "112 KB",
      },
      {
        title: "Size diagram — 3.5' × 16' banner",
        desc: "Render-style size diagram for the 3.5 ft × 16 ft banner configuration.",
        file: "/assets/dealer/threepost-diagram-3-5x16.jpg",
        type: "image", format: "JPG · 2000×1999", size: "118 KB",
      },
      {
        title: "Size diagram — 4' × 12' banner",
        desc: "Render-style size diagram for the 4 ft × 12 ft banner configuration.",
        file: "/assets/dealer/threepost-diagram-4x12.jpg",
        type: "image", format: "JPG · 2000×1999", size: "114 KB",
      },
      {
        title: "Size diagram — 4' × 16' banner",
        desc: "Render-style size diagram for the 4 ft × 16 ft banner configuration.",
        file: "/assets/dealer/threepost-diagram-4x16.jpg",
        type: "image", format: "JPG · 2000×1999", size: "112 KB",
      },
    ],
  },
  {
    id: "vconfig",
    name: "V-Configuration Kit",
    blurb: "Promo card and line-art diagram for the V-Config kit — holds two banners in a V, each 3'x6' to 4'x8'.",
    items: [
      {
        title: "V-Config kit — promo card",
        desc: "\"Supports 6' & 8' wide banners\" promo graphic with the supported-size lineup.",
        file: "/assets/dealer/vconfig-kit-promo.jpg",
        type: "image", format: "JPG · 1200×904", size: "208 KB",
      },
      {
        title: "Line art — V-Config with two banners",
        desc: "Line-art diagram of the V configuration. Supports two banners: 3'×6', 4'×6', 3'×8', or 4'×8'.",
        file: "/assets/dealer/vconfig-diagram-two-banners.jpg",
        type: "image", format: "JPG · 2000×1455", size: "125 KB",
      },
    ],
  },
  {
    id: "documents",
    name: "Product Documents",
    blurb: "Reference documents for listings, quotes, and print work.",
    items: [
      {
        title: "Product descriptions — all frame kits",
        desc: "Ready-to-use descriptions and included-items lists for the Small Form, Two Post, Three Post, and V-Config kits.",
        file: "/assets/dealer/product-descriptions.pdf",
        type: "pdf", format: "PDF · 4 pages", size: "6.4 MB",
      },
    ],
  },
];
